'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//endregion

//region CSS imports
require('ta-semantic-ui/semantic/dist/components/icon.css');
//endregion

//region React imports
function FacebookShareIcon(props) {
  return _react2.default.createElement(
    'a',
    {
      href: 'https://www.facebook.com/dialog/share?href=' + encodeURIComponent(props.shareUrl) + '&display=popup&app_id=' + props.facebookAppId + '&quote=' + encodeURIComponent(props.shareText) + '&hashtag=' + (props.hashtag ? encodeURIComponent('#' + props.hashtag) : ''),
      className: 'fb-share item' },
    props.facebookShares > 0 ? _react2.default.createElement(
      'small',
      { className: 'content count',
        style: { display: 'inline-block', marginRight: '0.33em' } },
      props.facebookShares
    ) : null,
    _react2.default.createElement('i', { className: 'facebook square icon', style: { height: '1.3em' } })
  );
}

FacebookShareIcon.propTypes = {
  shareUrl: _react2.default.PropTypes.string,
  facebookShares: _react2.default.PropTypes.number,
  facebookAppId: _react2.default.PropTypes.string,
  shareText: _react2.default.PropTypes.string,
  hashtag: _react2.default.PropTypes.string
};

FacebookShareIcon.defaultProps = {
  shareUrl: function () {
    return window.location;
  }(),
  facebookShares: 0,
  facebookAppId: '147124108642216',
  shareText: '',
  hashtag: ''
};

exports.default = FacebookShareIcon;


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-masthead/dist/facebookShareIcon.component.js
// module id = 114
// module chunks = 0